import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'form-input-text',
  template: `
    <div class="form-group">
      <label class="col-form-label font-weight-bold">{{label}}</label>&nbsp;&nbsp;
      <i *ngIf="labelInfo" pTooltip="{{labelInfo}}" class="fas fa-info-circle text-primary input-icon-right cursor-pointer"></i>
      <input type="text" class="form-control" 
             [class.is-invalid]="control.invalid && control.dirty"
             [placeholder]="placeholder" 
             [formControl]="control"
             (blur)="blur.emit($event)">
      <div *ngIf="control.invalid && control.dirty" class="text-danger-form">{{errorMsg ? errorMsg : 'campoObbligatorio' | translate}}</div>
    </div>
  `,
})
export class FormInputTextComponent {

  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() labelInfo: string;
  @Input() placeholder: string;
  @Input() errorMsg: string;

  @Output() blur: EventEmitter<any> = new EventEmitter();
}
